// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 1H4V23H11.5V17H6V3H18V11.0205C18.7087 11.079 19.3826 11.2607 20 11.544V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.7495 15.75V16.5H21.998V23H12.998V16.5H14.2495V15.75C14.2495 13.9551 15.7046 12.5 17.4995 12.5C19.2944 12.5 20.7495 13.9551 20.7495 15.75ZM18.7495 15.75C18.7495 15.0596 18.1899 14.5 17.4995 14.5C16.8092 14.5 16.2495 15.0596 16.2495 15.75V16.5H18.7495V15.75Z"}}]};

const PhoneLockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'phone-locked-filled',
    ref,
    icon: element,
  },
));

PhoneLockedFilledIcon.displayName = 'PhoneLockedFilledIcon';

export default PhoneLockedFilledIcon;
